import { useRef } from 'react';

/**
 * A stable id for THIS hook instance — one per mounted component, not one per
 * browser.
 *
 * Deliberately NOT the localStorage-backed deviceId() from useAppPresence:
 * localStorage is shared by every tab of one origin, so two TraderView tabs
 * would land on the same presence node and overwrite each other exactly as they
 * did before #167.
 *
 * The ref survives effect re-runs, so changing the watched accounts updates the
 * same presence node rather than leaking a new one on every navigation.
 */
export function usePresenceInstanceId(): string {
    const ref = useRef<string | null>(null);
    if (ref.current === null) ref.current = crypto.randomUUID();
    return ref.current;
}
